module.exports = __webpack_public_path__ + "img/vegetable-mushrooms-350x184.092d7b6c.jpg";